export function dtCheck(option){
  var el=option.el;
  var father=el.parentNode;
  var isSelected=option.defaultSelected || false;
  var className=option.className;
  //将隐藏checkbox插入
  var checkbox=document.createElement("checkbox");
  if(option.defaultSelected){
    ckeckbox.selected=true;
  }
  father.insertBefore(checkbox,el.nextSibling)

  //点击事件
  el.onclick=function(){
    if(isSelected){
      el.className=el.className.replace(className,"");
      isSelected=false;
    }
    else{
      el.className+=" "+className;
      isSelected=true;
    }
  }
  var DtCheck=function(){

  }
  DtCheck.prototype.isSelected=function(){
    return isSelected;
  }
  return new DtCheck();
}



// WEBPACK FOOTER //
// ./src/util/dt-checkbox/index.js